import _ from "lodash";

const config = {
  debug : false,
  authGoesToVIP: false,
  appBasename: 'login',
  sentry_release: '2.32.91.189', //gets set within Makefile prod
  sentry_dist: '2.32.91.189', //gets set within Makefile prod

  // debug : true,
  // authGoesToVIP: false,
  // appBasename: 'login',
  // sentry_release: null,
  // sentry_dist:null,

  versions: {
    web : 116
  },

  showPDFFixerTool : false,

  prodEndpoint: 'https://verifyle.com',
  endpoints: [
    'https://verifyle.com',
    'https://stage.vfltest.com',
    'https://qa1.vfltest.com',
    'https://qa2.vfltest.com',
    'https://qa3.vfltest.com',
    'https://qa4.vfltest.com',
    'https://dev2.vfltest.com',
    'https://dev3.vfltest.com',
    'https://dev4.vfltest.com'
  ],
  useAlwaysPassCaptcha: (endpoint) => {
    if(config.debug){
      return true;
    }
    let isProdEndpoint = endpoint.indexOf('verifyle.com') >= 0 || endpoint.indexOf('stage.vfltest.com') >= 0;
    if(isProdEndpoint){
      return false;
    }

    let didFind = _.find(config.endpoints, (e) => endpoint.indexOf(e) >= 0);
    if(didFind){
      return true;
    }

    return config.debug;
  }
}

export default config;
